export enum DiscountTypeEnum {
  VOUCHER,
  GIFT_CARD
}
